import React from 'react';

const IconBelgium = props => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 55.2 38.4" {...props}>
      <g fillRule="evenodd" clipRule="evenodd">
        <path
          fill="#000"
          d="M3.03 0h49.13c1.67 0 3.03 1.36 3.03 3.03v32.33c0 1.66-1.36 3.02-3.02 3.03H3.02C1.36 38.4 0 37.03 0 35.37V3.03C0 1.36 1.36 0 3.03 0z"
        />
        <path fill="#fdda24" d="M18.4 0h18.4v38.4H18.4z" />
        <path
          fill="#ef3340"
          d="M36.8 0h15.37c1.67 0 3.03 1.36 3.03 3.03v32.33c0 1.66-1.36 3.02-3.02 3.03H36.8V0z"
        />
      </g>
    </svg>
  );
};

export default IconBelgium;
